import type { FaireProductEntity } from "../../entity_types/product";

export const p_cfqkfcyyb3: FaireProductEntity = {
  token: "p_cfqkfcyyb3",
  type: "product",
  name: "Love, Paris 9 oz Glass Candle",
  brandToken: "b_8ed70fdd",
  brandName: "Rifle Paper Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/865a008683a2f86469e3d95ef699bbc583ec8a6cd0c758c8dd3dd30ef77ebadd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be3e25b82a397d7314fdc2fd547e7f7bef02cccbdd1bdb81a3721c9569c1a5af.jpeg",
    "https://cdn.faire.com/fastly/406ffd0731a23b4151fdbd28f4f7d18de914afd20078711e73e627508d1aad06.jpeg",
  ],
  priceDollars: 19,
  description:
    "Layered and floral, Jardin de Paris plays homage to blooming French gardens and the iconic elements of Parisian style: classic and feminine. The 9.5oz soy wax candle comes in a painted glass vessel and is packaged in a decorative gift box with gold foil accents.\n\nDETAILS\n\n- Glass vessel with soy candle base\n- 9.5 oz\n- 40+ hour burn time\n- Notes of peony, white tea, gardenia, and sandalwood\n- Decorative box with gold foil accents\n- Label printed in full color with metallic gold ink accents\n- Poured in the USA",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:31.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
